/**
 * This helper is supposed to be used for every allowed log in the application.
 * Currently logged messages and errors may later be stored for development et debug purposes.
 */

/* eslint-disable no-console */

function logError(...error: any[]) {
  console.log('[ERR]', ...error);
}

function logMessage(...message: any[]) {
  console.log('[MSG]', ...message);
}

function log(...args: any[]) {
  console.log(...args);
}

/**
 * Execute the function passed as parameter, returns its results, and log its execution time (in ms).
 * @param timedFunction the function that will be tested
 * @param message additional message to the function
 */
function logTime(timedFunction: () => any, message = 'Function executed in'): any {
  const d1 = new Date().valueOf();
  const returnedValue = timedFunction();
  const d2 = new Date().valueOf();
  console.log(message, d2 - d1, 'ms');
  return returnedValue;
}

export default {
  logMessage,
  logError,
  log,
  logTime
};
